/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var FormValidation = /** @class */ (function () {
    function FormValidation(validators) {
        this.validators = validators;
    }
    FormValidation.prototype.attachValidation = function (form, config) {
        this.validators.forEach(function (validator) {
            validator.attachValidation(form, config);
        });
    };
    return FormValidation;
}());
export { FormValidation };
